import { MAX_DATEV_ACCOUNT_NUMBER_LENGTH, MIN_DATEV_ACCOUNT_NUMBER_LENGTH } from "@finway-group/shared/lib/consts/datevConsts"
import { DatevCsvConfig } from "@finway-group/shared/lib/models"
import { type Rule } from "antd/lib/form"
import { i18n } from "~Shared/locales/i18n"

export const createDatevCsvConfigRules = (): Record<keyof DatevCsvConfig, Array<Rule>> => ({
    walletAccount: [{ required: true, message: i18n.t("validation:required") }],
    cashTransitAccount: [{ required: true, message: i18n.t("validation:required") }],
    accountNumberLength: [
        {
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.reject(i18n.t("validation:required"))
                }

                if (parseInt(value) < MIN_DATEV_ACCOUNT_NUMBER_LENGTH || parseInt(value) > MAX_DATEV_ACCOUNT_NUMBER_LENGTH) {
                    return Promise.reject(i18n.t("validation:numeric_min_max", { min: MIN_DATEV_ACCOUNT_NUMBER_LENGTH, max: MAX_DATEV_ACCOUNT_NUMBER_LENGTH }))
                }

                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
